// extracted by mini-css-extract-plugin
module.exports = {"productLimitBox":"_2uqVR","topTitle":"_1n8G2","redDot":"_2OxM0","line":"_3ovrQ","bottom":"_2VS71","bottomBox":"_26p1w","update":"_1jZdx"};